import React from 'react';
import { useAuthContext } from '../../context/AuthContext';
import { usePageTitle } from '../../hooks/usePageTitle';

const TeamManagement: React.FC = () => {
  usePageTitle('Team Management | From the Pitchside');

  const { user } = useAuthContext();

  return (
    <div className="text-darkblue">
        <h2>Team Management</h2>
    </div>
  );
};

export default TeamManagement;
